import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardRepository } from '../../../infrastructure/repositories/dashboard.repository';
import { UpdateDashboardPreferencesCommand } from './update-dashboard-preferences.command';

@Injectable({ providedIn: 'root' })
export class UpdateDashboardPreferencesUseCase {
  private readonly _repository = inject(DashboardRepository);

  public execute(command: UpdateDashboardPreferencesCommand): Observable<void> {
    return this._repository.updatePreferences(command);
  }
}
